export const DEFUALT_LOCALE = "en-US";

export const SUPPORTED_LOCALES = ["en-US", "fr-CA"] as const;

export const RTL_LOCALES: SupportedLocale[] = [];

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
